import { useState } from "react";
import { motion } from "framer-motion";
import { Plus, Phone } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { FAQS, BIZ } from "@/content";

const Item = ({ i, q, a, open, onToggle }) => (
  <div className={`rounded-[1.5rem] border transition-colors duration-300 ${open ? "border-[#FF6B00] bg-white" : "border-slate-200 bg-[#FAF9F6] hover:border-slate-300"}`} data-testid={`faq-item-${i}`}>
    <h3>
      <button type="button" onClick={onToggle} aria-expanded={open} aria-controls={`faq-answer-${i}`} id={`faq-question-${i}`}
        className="flex w-full items-center justify-between gap-6 p-6 text-left sm:p-7" data-testid={`faq-question-${i}`}>
        <span className="font-display text-lg font-extrabold tracking-tight text-[#0F2B5B] sm:text-xl">{q}</span>
        <span className={`grid h-10 w-10 shrink-0 place-items-center rounded-full transition-[background-color,transform] duration-300 ${open ? "rotate-45 bg-[#FF6B00] text-white" : "bg-white text-[#0F2B5B] ring-1 ring-slate-200"}`}>
          <Plus className="h-5 w-5" />
        </span>
      </button>
    </h3>
    <motion.div id={`faq-answer-${i}`} role="region" aria-labelledby={`faq-question-${i}`}
      initial={false} animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="overflow-hidden" data-testid={`faq-answer-${i}`}>
      <p className="px-6 pb-7 text-base leading-relaxed text-slate-600 sm:px-7">{a}</p>
    </motion.div>
  </div>
);

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="bg-white py-24 lg:py-32" data-testid="faq-section">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 lg:grid-cols-12 lg:px-10">
        <Reveal className="lg:col-span-4">
          <Eyebrow>Good to know</Eyebrow>
          <h2 className="font-display text-4xl font-extrabold leading-[1] tracking-tight text-[#0F2B5B] sm:text-6xl">Plumbing questions, answered.</h2>
          <p className="mt-6 max-w-sm text-base text-slate-600 md:text-lg">Straight answers to the things Perth homeowners ask us most. Not covered here? Ask Roo in the chat or give us a call.</p>
          <a href={BIZ.tel} className="mt-8 inline-flex items-center gap-2 font-display text-2xl font-extrabold text-[#0F2B5B] hover:text-[#E05A00]" data-testid="faq-call-link">
            <Phone className="h-5 w-5 text-[#FF6B00]" /> {BIZ.phone}
          </a>
        </Reveal>
        <Reveal className="space-y-4 lg:col-span-8" delay={0.1}>
          {FAQS.map((f, i) => (
            <Item key={f.q} i={i} q={f.q} a={f.a} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
          ))}
        </Reveal>
      </div>
    </section>
  );
};
